import { AppBundle } from 'api/optimalprint-sdk.d';

const getRouteParamValue = (
  route: AppBundle.Api.Response.App.V1.RoutingListV1Response.Route & { parameters: { name: string; value: string }[] },
  key: string,
) => {
  if (!route.parameters) return undefined;
  const values = route.parameters.filter((p) => p.name === key);
  if (!values.length) return undefined;
  return values[0].value;
};

export default getRouteParamValue;
